import Link from 'next/link'
import React from 'react'
import { clusterForSlug, guideHref } from '../../../../utils/aircon-guide-clusters'

/**
 * Bottom-of-guide links: the service this guide's topic is about, and other
 * guides on the same topic (utils/aircon-guide-clusters.js). Replaces "the six
 * newest posts in the category" as the only way out of a guide.
 */
export const AirconGuideLinks = ({ slug, related = [] }) => {
    const cluster = clusterForSlug(slug)
    // Some in-repo "guides" are the service pages themselves; the button already links those.
    related = related.filter((guide) => guideHref(guide.slug) !== cluster.service.href)

    return (
        <section className="max-w-5xl mx-auto px-4" aria-labelledby="aircon-guide-links">
            <div className="rounded-2xl border border-orange-200/60 bg-orange-50/40 p-6 space-y-5">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                    <h2 id="aircon-guide-links" className="text-xl font-bold text-gray-900">
                        More on {cluster.title.toLowerCase()}
                    </h2>
                    <Link href={cluster.service.href} prefetch={false}
                        className="inline-block text-center rounded-xl bg-orange-600 text-white font-semibold px-5 py-2.5 hover:bg-orange-700">
                        {cluster.service.label}
                    </Link>
                </div>
                <p className="text-xs text-gray-600">
                    Written by the StringsSG Aircon Team.{' '}
                    <Link href="/sg/aircon-servicing-singapore/how-stringssg-works#guides" prefetch={false} className="text-orange-600 hover:underline">
                        How our guides are written
                    </Link>
                </p>
                {related.length > 0 && (
                    <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2">
                        {related.map((guide) => (
                            <li key={guide.slug}>
                                <Link href={guideHref(guide.slug)} prefetch={false} className="text-orange-600 hover:underline">
                                    {guide.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </section>
    )
}
